import React from 'react'
import { iconMap } from '@mortgage-pos/ui/utils/customizationHelpers'

const ValueProps = () => {
  return (
    <section className="br-value-props__wrapper">
      <h2 className="br-value-props__heading">Get the most from your money</h2>
      <ul className="br-value-props__list">
        <li className="br-value-props__item">
          <figure className="br-value-props__icon-wrapper">
            <img
              className="br-value-props__icon"
              src={iconMap('valuePropMoney')}
              alt="Rates icon"
            />
          </figure>
          <h3 className="br-value-props__item-heading">Custom rates</h3>
          <p className="br-value-props__item-blurb">
            These are real offers based on your unique financial situation.
          </p>
        </li>
        <li className="br-value-props__item">
          <figure className="br-value-props__icon-wrapper">
            <img
              className="br-value-props__icon"
              src={iconMap('valuePropInfo')}
              alt="Precise info icon"
            />
          </figure>
          <h3 className="br-value-props__item-heading">Precise info</h3>
          <p className="br-value-props__item-blurb">
            We survey national lenders daily to bring you the most accurate
            rates available.
          </p>
        </li>
        <li className="br-value-props__item">
          <figure className="br-value-props__icon-wrapper">
            <img
              className="br-value-props__icon"
              src={iconMap('valuePropLowRates')}
              alt="Low Rate icon"
            />
          </figure>
          <h3 className="br-value-props__item-heading">Lower offers</h3>
          <p className="br-value-props__item-blurb">
            On Bankrate, you'll find rates that are consistently lower than the
            national average.
          </p>
        </li>
      </ul>
    </section>
  )
}

export default ValueProps
